import React, { useState } from 'react'
import { withChildren } from '@builder.io/react'
import ModalContentGreetingCards from './ModalContentGreetingCards'
import { styled } from '../../../../stitches.config'

const TriggerWrapper = styled('div', {
    cursor: 'pointer',
})

const ModalTriggerGreetingCards = (props: any) => {
    const [isOpen, setIsOpen] = useState(false)

    return (
        <>
            <TriggerWrapper onClick={() => setIsOpen(!isOpen)}>
                {props.children}
            </TriggerWrapper>

            <ModalContentGreetingCards isOpen={isOpen} setIsOpen={setIsOpen} />
        </>
    )
}

////// This is a Builder Custom Component that will accept any children
////// as configured within Builder. This will allow it to contain whatever elements
////// are desired, and trigger the modal when they are clicked.
const ModalTriggerGreetingCardsWithBuilderChildren = withChildren(
    ModalTriggerGreetingCards
)

export default ModalTriggerGreetingCardsWithBuilderChildren
